<template>
  <div>
    <br>
    <form>
      <div class="form-group">
        <b-btn @click="deleteButtonClick = true">Delete Customer</b-btn>
        <span v-if="deleteButtonClick"><span class="error"> Are you Sure? -- </span><span><b-btn @click="deleteCustomerFn(customerDetail._id)">Yes</b-btn> / <b-btn @click="deleteButtonClick = false">No</b-btn></span></span>
        <br>
        <br>
        <label for="custName">Customer Name:</label>
        <input name="CUSTNAME" type="text" class="form-control" id="custName" :value="customerDetail.Name" @change="updateCustomerChanged">
        <span style="color: red">{{ fieldErrors.Name }}</span>
      </div>
      <label for="Type"  >Customer Type</label>
        <select name="TYPE" id="Type" class="form-control custom-select"  :value="customerDetail.Type" @change="updateCustomerChanged">
          <option value="UK">UK - All Collections</option>
          <option value="EU">EU - All EU Collections</option>
          <option value="Export">Export - All Export Collections</option>
          <option value="Restricted">Restricted - Choose Which Collections to Allow</option>
        </select>
        <label for="Role"  >User or Admin</label>
        <select name="ROLE" id="Role" class="form-control custom-select"  :value="customerDetail.Role" @change="updateCustomerChanged">
           <option value="User">User</option>
          <option value="Admin">Administrator</option>
        </select>

      <br>
      <div v-if="changes.length>0">
        <b-btn class="btn btn-primary" @click="submitForm">Save Changes</b-btn>
        <b-btn class="btn btn-primary" @click="submitAbandon">Abandon Changes</b-btn>
      </div>
    </form>
    <div>
      <br>
      <table class="tbl tblStriped">
        <th>
          <p v-if="customerDetail.Type==='Restricted'">Allowed Collections</p>
          <p v-if="customerDetail.Type !=='Restricted'">Disallowed Collections</p>
        </th>
        <th>Region</th>
        <th class="tblBtn">
        </th>
        <tr class="redP" v-for="coll in collsAllowed2" :key="coll.Name">
          <td>{{coll.Name}}</td>
          <td>{{coll.Region}}</td>
          <td class="tdBtn">
            <b-btn name="coll._Id" class="tblBtn" v-if="customerDetail.Type ==='Restricted'" @click="btnAllow(coll._id, 'dis', 'res')">Disallow</b-btn>
            <b-btn name="coll._Id" class="tblBtn" v-if="customerDetail.Type !=='Restricted'" @click="btnAllow(coll._id, 'all', 'unres')">Allow</b-btn></td>
        </tr>
      </table>
    </div>
    <br>
    <table class="tbl tblStriped">
        <th>
          <p v-if="customerDetail.Type==='Restricted'">Disallowed Collections</p>
          <p v-if="customerDetail.Type !=='Restricted'">Allowed Collections</p></th>
          <th>Region</th>
        <th class="tblBtn">
        </th>
        <tr v-for="collection in collsRemaining2" :key="collection._id">
        <td>{{collection.Name}}</td>
        <td>{{collection.Region}}</td>
        <td class="tdBtn">
          <b-btn name="collection._Id" class="tblBtn" v-if="customerDetail.Type ==='Restricted'" @click="btnAllow(collection._id, 'all', 'res')">Allow</b-btn>
          <b-btn name="collection._Id" class="tblBtn" v-if="customerDetail.Type !=='Restricted'" @click="btnAllow(collection._id, 'dis', 'unres')">Disallow</b-btn>
        </td>
        </tr>
      </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import customerCollections from './CustomerCollections'
export default {
  name: 'CustomerDetail',
  props: ['auth', 'authenticated', 'cust', 'customerDetail'],
  components: {
  },
  computed: {
    ...mapGetters({
      changes: 'changes',
      fields: 'fields',
      collectionsLive: 'collectionsLive'
    }),
    collsAllowed2 () {
      return this.collsAllowed().sort((a, b) => {
        let x = a.Name.toLowerCase()
        let y = b.Name.toLowerCase()
        if (x < y) { return -1 }
        if (x > y) { return 1 }
      })
    },
    collsRemaining2 () {
      return this.collsRemaining().sort((a, b) => {
        let x = a.Name.toLowerCase()
        let y = b.Name.toLowerCase()
        if (x < y) { return -1 }
        if (x > y) { return 1 }
      })
    }
  },
  methods: {
    ...mapActions([
      'getCustomerDetail',
      'updateCustomer',
      'getCollectionsLive',
      'adjustCustomerCollections',
      'updateCustomerDetail',
      'deleteCustomer'
    ]),
    // save customer chnges to database
    submitForm (evt) {
      evt.preventDefault()
      this.fieldErrors = this.validateForm(this.customerDetail.Name)
      if (Object.keys(this.fieldErrors).length) return
      this.updateCustomer(this.customerDetail)
    },
    // abandon customer changes i.e. reload customer from database
    submitAbandon (evt) {
      evt.preventDefault()
      this.getCustomerDetail(this.customerDetail.Acc)
    },
    // check customer details for errors
    validateForm (fields) {
      const errors = {}
      if (!this.customerDetail.Name) errors.Name = 'Please Enter a Name'
      return errors
    },
    // update store with customer changes
    updateCustomerChanged (evt) {
      const element = evt.target
      const aa = this.fields[`${element.name}`]
      function findElement () {
        return element.name
      }
      const value = element.value

      if (value === aa) {
        let inChanges = this.changes.findIndex(findElement)
        if (inChanges > -1) {
          this.changes.splice(inChanges, 1)
        }
      } else {
        if (!this.changes.includes(element.name)) {
          this.changes.push(element.name)
        }
      }
      this.$store.commit(`UPDATE_CUSTOMER_${element.name}`, value)
    },
    deleteCustomerFn (Id) {
      this.deleteCustomer(Id)
        .then((response) => {
          this.$store.dispatch('getCustomers')
          this.deleteButtonClick = false
          this.$store.commit('CLEAR_CUSTOMER_DETAIL')
        })
    },
    collsAllowed () {
      let cust = this.customerDetail
      let collAllowed = []
      if (cust.Type === 'Restricted') { collAllowed = cust.CollectionsAllowed } else { collAllowed = cust.CollectionsDisallowed }
      let allColls = []
      if (cust.Type === 'EU') {
        allColls = this.collectionsLive.filter(filtered => filtered.Region !== 'UK')
      } else if (cust.Type === 'Export') {
        allColls = this.collectionsLive.filter(filtered => filtered.Region === 'EXPORT')
      } else {
        allColls = this.collectionsLive
      }
      let matchedColls = []
      collAllowed.forEach((e1) => allColls.forEach((e2) => {
        if (e1 === e2._id) {
          matchedColls.push(e2)
        }
      }
      ))
      return matchedColls
    },
    collsRemaining () {
      let cust = this.customerDetail
      let unmatchedColls = []
      let allColls = []
      if (cust.Type === 'EU') {
        allColls = this.collectionsLive.filter(filtered => filtered.Region !== 'UK')
      } else if (cust.Type === 'Export') {
        allColls = this.collectionsLive.filter(filtered => filtered.Region === 'EXPORT')
      } else {
        allColls = this.collectionsLive
      }
      allColls.forEach((e1) => {
        let aa = this.collsAllowed().findIndex((aa) => {
          return aa === e1
        })
        if (aa === -1) {
          unmatchedColls.push(e1)
        }
      })
      return unmatchedColls
    },
    btnAllow (id, all, res) {
      let allow = false
      let restricted = false
      if (all === 'all') allow = true
      if (res === 'res') restricted = true
      let payload = { 'id': id, 'allow': allow, 'restricted': restricted }
      this.updateCustomerDetail(payload)
    }
  },
  created () {
  },
  data () {
    return {
      fieldErrors: {
        Name: undefined
      },
      deleteButtonClick: false
    }
  },
  mounted () {
  }
}
</script>

<style>
.redP {
  color: red
}

</style>
